import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import Homepage from "../components/pages/Homepage";
import Navbar from "../components/pages/Navbar";
import Footer from "../components/pages/Footer";
import ProductDetails from "../components/pages/ProductDetails";
import Cart from "../components/pages/Cart";
import Checkout from "../components/pages/Checkout";
import Login from "../components/pages/Login";
import Register from "../components/pages/Register";

import MyOrders from "../components/pages/MyOrders";
import MyAddresses from "../components/pages/MyAddresses";
import PageNotFound from "../components/pages/404page";
import ProtectedRoute from "../components/common/ProtectedRoute";
import PublicRoute from "../components/common/PublicRoute";
import ForgotPassword from "../components/pages/ForgotPassword";
import ResetPassword from "../components/pages/ResetPassword";
import { useTheme } from "../theme/ThemeContext";
const AllRoutes = () => {
  const theme = useTheme();
  const location = useLocation();
  
  // Pages where footer should be hidden
  const hideFooterPaths = [
    "/login",
    "/register",
    "/forgot-password",
    "/reset-password",
  ];
  
  const shouldShowFooter = !hideFooterPaths.includes(location.pathname);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundColor: theme?.store_background_color,
      }}
    >
      <Navbar />
      <Box
        component="main"
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Routes>
          {/* Protected Routes - Require login if login_required is true */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Homepage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-orders"
            element={
              <ProtectedRoute>
                <MyOrders />
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-addresses"
            element={
              <ProtectedRoute>
                <MyAddresses />
              </ProtectedRoute>
            }
          />
          <Route
            path="/products/:id"
            element={
              <ProtectedRoute>
                <ProductDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cart"
            element={
              <ProtectedRoute>
                <Cart />
              </ProtectedRoute>
            }
          />
          <Route
            path="/checkout"
            element={
              <ProtectedRoute>
                <Checkout />
              </ProtectedRoute>
            }
          />

          {/* Public Routes - Login/Register pages */}
          <Route
            path="/register"
            element={
              <PublicRoute>
                <Register />
              </PublicRoute>
            }
          />
          <Route
            path="/login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />

          <Route
            path="/forgot-password"
            element={
              <PublicRoute>
                <ForgotPassword />
              </PublicRoute>
            }
          />

          <Route
            path="/reset-password"
            element={
              <PublicRoute>
                <ResetPassword />
              </PublicRoute>
            }
          />

          {/* 404 page - Always accessible */}
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </Box>
      {shouldShowFooter && <Footer />}
    </Box>
  );
};

export default AllRoutes;
